import React from "react";
import "./term.css"
import { Button, Card, CardBody, CardGroup, CardText, Container, Row } from "reactstrap";
import { CardCustom2 } from "../CardCustom/CardCustom";
function Term() {

  const data = [
    {
      title: "Informasi penting untuk NIEC Global Ambassador", 
      text: `Syarat dan kondisi dari perjanjian ini ditetapkan di bawah ini. 
            Pastikan Anda telah membaca dan memahami kondisi sebelum masuk ke dalam perjanjian. 
            Dengan menyetujui (klik OK pada halaman terakhir), maka kami menganggap bahwa 
            Anda telah membaca dan memahami syarat NIEC Global Ambassador.`
    },
    {
      title: "Syarat menjadi NIEC Global Ambassador", 
      text: `Untuk menjadi NIEC Global Ambassador dapat ditempuh dengan cara sebagai berikut`,
      list: [
        "Sudah berusia minimal 18 (depalan belas) tahun, yang dibuktikan dengan KTP (Kartu Tanda Penduduk).", 
        "Mendaftar di website milik PIHAK PERTAMA, yaitu melalui: www.ambassador.niecindonesia.com", 
        "Menandatangani Perjanjian Kerja Sama sebagai NIEC Global Ambassador."
      ],
    },  
    {
      title: "Tanggung jawab NIEC Global Ambassador", 
      text: "Tanggung jawab NIEC Global Ambassador adalah sangat mudah, cukup dengan:",
      list: [
        `Merekomendasikan kenalan, teman, ataupun keluarga (nama & nomor telepon) 
        yang ingin kuliah di luar negeri kepada NIEC."`, 
        `Program kuliah di luar negeri bisa dalam bentuk jenjang Diploma, 
        Bachelor (S1), Master (S2), dan Ph.d. (S3).`, 
        `Siswa yang direkomendasikan ke NIEC harus terlebih dahulu melalui 
        persetujuan dari yang bersangkutan.`
      ],      
    },
    {
      title: "Hak NIEC Global Ambassador", 
      list: [
        `Berhak menghubungi NIEC untuk mengetahui informasi perkembangan 
        siswa yang direkomendasikan melalui info@niecindonesia.com atau ke 0812 3843 1234`, 
        "Berhak memperoleh insentif dan bonus lainnya."
      ],      
    },          
    {
      title: "Tanggung Jawab NIEC Global Ambassador", 
      list: [
        `Menfollow up data yang telah diberikan oleh NIEC Global Ambassador.`, 
        `Mengurus proses kuliah di luar negeri mulai dari konsultasi pemilihan 
        jurusan, kampus, negara, LoA, document visa, homestay di luar negeri dll.`,
        `Menginformasikan perkembangan siswa yang direkomendasikan jika 
        NIEC Global Ambassador meminta.`, 
        `Memberikan insentif dan bonus kepada NIEC Global Ambassador sesuai dengan 
        perjanjian yang nantinya akan disepakati.`, 
      ],      
    },   
    {
      title: "Insentif dan bonus", 
      text: `NIEC Global Ambassador akan mendapat insentif yang besarannya akan dijelaskan dalam perjanjian yang akan dikirim setelah anda melakukan registrasi ini.`
    },           
  ];

  return (
    <section id="term" className="term">
      <Container>
        <h1 className="text-center pb-2">Syarat dan Ketentuan</h1>
        <Row className="p-2 p-md-0">
          <Card className="card-custom-2">
            <div className="card-bg"></div>
            <div className="index">
              {data.map((item, id) => (
                <CardCustom2 key={id} title={item.title} text={item.text} list={item.list}/>
              ))}    
            </div>        
          </Card> 
        </Row>
      </Container>
    </section>
  );
}

export default Term;